import React, { useEffect } from "react";
import * as BosIdentityServices from "data/BosWebServices/BosIdentityServices";
import LoginHeader from "./LoginHeader";
import { getTranslation as translate } from "logic/LocaleManager";

import { LOGINTYPE_LOGIN, LOGINTYPE_VERIFY_USER } from "pages/Login/LoginPage";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as bosUserActions from "../../redux/actions/bosUserActions";

function VerifyUser(props) {
  const { verifyToken, changeLoginType, actionSuccessfull, actionError, setIsLoading } = props;
  const resetFailedText = translate("verifyUser.failed", "Email verification failed!");
  const resetSuccessText1 = translate("verifyUser.success", "Email verification OK for: ");
  const resetSuccessText2 = translate("verifyUser.success2", "You can now login");

  useEffect(() => {
    if (verifyToken)
      tokenVerfiy(verifyToken);
    else
      gotoLogin();
  }, [verifyToken]);

  async function tokenVerfiy(token) {
    try {
      setIsLoading(true);
      let result = await BosIdentityServices.fetchEmailVerification(token);
      actionSuccessfull(LOGINTYPE_VERIFY_USER, null, resetSuccessText1 + result.userDisplayName + "<br>" + resetSuccessText2);
      setIsLoading(false);
    } catch (error) {
      actionError(resetFailedText + " (" + error + ")");
      setIsLoading(false);
    }
  }

  function gotoLogin() {
    changeLoginType(LOGINTYPE_LOGIN);
  }

  return (
    <LoginHeader title={translate("verifyUser.title", "Verify")} description={translate("verifyUser.description", "Checking User...")} />
  );
}

function mapDispatchToProps(dispatch) {
  return {
    bosUserActions: bindActionCreators(bosUserActions, dispatch)
  };
}

export default connect(
  null,
  mapDispatchToProps
)(VerifyUser);
